<div class="table-section">
  <lx-price-lists-portal-table-header [title]="tableTitle" [currency]="currency"></lx-price-lists-portal-table-header>
  <ng-container [ngSwitch]="company">
    <lx-price-lists-portal-positively-languages-accommodation-table
      *ngSwitchCase="companyEnum.KIL"
      [accommodations]="accommodations"
      [notationMarks]="notationMarks"
    ></lx-price-lists-portal-positively-languages-accommodation-table>
    <lx-price-lists-portal-alp-accommodation-table
      *ngSwitchCase="companyEnum.ALP"
      [accommodations]="accommodations"
      [notationMarks]="notationMarks"
    ></lx-price-lists-portal-alp-accommodation-table>
  </ng-container>
  <lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
</div>
